var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"categories"},[_c('h5',{staticClass:"mb-5"},[_vm._v("Categorias")]),_c('carousel',{attrs:{"per-page-custom":[
      [768, 4],
      [992, 6],
      [1300, 6]
    ],"navigation-enabled":true,"navigation-next-label":"<i class='icon-angle-right'></i>","navigation-prev-label":"<i class='icon-angle-left'></i>"}},_vm._l((_vm.items),function(item){return _c('slide',{key:item.id,staticClass:"px-3",attrs:{"aria-hidden":"true"}},[_c('category',{attrs:{"name":item.name},on:{"select":_vm.click}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }